module.exports = __webpack_public_path__ + "static/media/card-selected.7eacde6e.svg";